import axios from "axios";

// The dashboard client logs the merchant out on some 401 answers; a customer's expired login token must not.
const publicHttp = axios.create({
  baseURL: process.env.REACT_APP_UMD_BACK_END_DOMAIN || "/umd-service/api",
});

export default publicHttp;
